import { useRouter } from "next/router";
import Link from "next/link";

export default function LocationListItem({
  slug,
  title,
  isPlaceOfHome,
  hasMemorial,
  type,
  centerIcon,
  memorialIcon,
}) {
  const router = useRouter();

  const getTextColor = () => {
    if (isPlaceOfHome) return "text-black";
    return "text-gamma";
  };

  return (
    <li
      id={slug}
      className={`location-list-item flex items-center mb-1 ${getTextColor()}`}
    >
      <a onClick={() => router.push(`/locations/${slug}`)}>{title}</a>
      {type === "center" ? (
        <div
          dangerouslySetInnerHTML={{ __html: centerIcon }}
          className="icon center-icon w-4 ml-2"
        />
      ) : null}
      {hasMemorial ? (
        <Link href={{ pathname: "/locations/memorials/[slug]", query: { slug } }}>
          <a
            dangerouslySetInnerHTML={{ __html: memorialIcon }}
            className="icon memorial-icon w-4 ml-2"
          />
        </Link>
      ) : null}
    </li>
  );
}
